import { render, staticRenderFns } from "./order-log.vue?vue&type=template&id=ec621fe4&scoped=true&"
import script from "./order-log.vue?vue&type=script&lang=js&"
export * from "./order-log.vue?vue&type=script&lang=js&"
import style0 from "./order-log.vue?vue&type=style&index=0&id=ec621fe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec621fe4",
  null
  
)

export default component.exports